export default __webpack_public_path__ + "static/media/pandas-banner.0a45642d.png";